import uuidv4 from 'uuid/v4'
import {
  ImageFileWithObjectURL,
  FileMetadata,
  IndexedFilesAndMetadata
} from '../types/files'

const blobToFile = (blob: Blob, fileName: string) =>
  new File([blob], fileName, { type: blob.type })

const imageFilesWithObjectURLToFiles = async (
  imageFilesWithObjectURL: ImageFileWithObjectURL[]
) => {
  let files: File[] = []
  for (const imageFileWithObjectUrl of imageFilesWithObjectURL) {
    try {
      const { src, path } = imageFileWithObjectUrl
      /** add handling here if unable to create blob (not in memory etc) */
      const blob = await fetch(src).then((result) => result.blob())
      const file = blobToFile(blob, path)
      URL.revokeObjectURL(src)
      files = [...files, file]
    } catch (error) {
      // just here to avoid breaking the whole process TODO ADD LOGGING
    }
  }
  return files
}

const getFileMetadata = (file: File): FileMetadata => ({
  id: uuidv4(),
  name: file.name,
  sizeMB: file.size / (1024 * 1024),
  type: file.type
})

const getFilesMetadataAndIndex = (files: File[]) =>
  files.reduce((filesAcc: IndexedFilesAndMetadata, file: File) => {
    const metadata = getFileMetadata(file)

    filesAcc = {
      ...filesAcc,
      [metadata.id]: { file, metadata }
    }
    return filesAcc
  }, {})

export {
  imageFilesWithObjectURLToFiles,
  getFileMetadata,
  getFilesMetadataAndIndex
}
